import NotFoundClient from "./client";

export default function NotFound({ params, searchParams }) {
  return (
  <NotFoundClient />
  );
}
